// extracted by mini-css-extract-plugin
module.exports = {"security":"Security_security__J-WEe","container":"Security_container__iUdp5","form":"Security_form__38ZQ0"};